import Button from "components/atoms/Button/Button";
import { Card } from "components/atoms/Card";
import Loading from "components/atoms/Loading/Loading";
import PixelHelper from "helpers/PixelHelper";
import React, { useEffect } from "react";
import { CopyBlock, a11yDark as themeBlock } from "react-code-blocks";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  createCompanyPixel,
  getCompanyPixel,
  resetAddCompanyPixelState,
  resetCompanyPixelState,
} from "store/slices/company.slice";
import { RootState } from "store/store";
import { Empty } from "components/atoms/Empty";
import Icon from "components/atoms/Icon/Icon";

const CompanyPixel: React.FC = () => {
  const dispatch = useAppDispatch();
  const companyPixel = useAppSelector(
    (state: RootState) => state.company.companyPixel
  );
  const { isSuccess, isLoading } = useAppSelector(
    (state) => state.company.companyPixel
  );
  const {
    isSuccess: isAddSuccess,
    errorMessage: addErrorMessage,
    isLoading: isAddLoading,
  } = useAppSelector((state) => state.company.addCompanyPixel);
  useEffect(() => {
    dispatch(resetCompanyPixelState());
    dispatch(resetAddCompanyPixelState());
    dispatch(getCompanyPixel());
  }, [dispatch]);
  const handleCreatePixel = () => {
    dispatch(createCompanyPixel());
  };
  const identityMatrixTheme = {
    ...themeBlock,
    lineNumberBgColor: "transparent",
    commentColor: "var(--color-gray-100)",
    backgroundColor: "transparent",
  };
  return (
    <div className={`flex flex-col w-full gap-5`}>
      {isLoading ? (
        <div className="flex items-center gap-3">
          <Loading height="38px" spinnerSize={32} />
        </div>
      ) : (isSuccess || isAddSuccess) && companyPixel.data?.trackingCode ? (
        <>
          <CopyBlock
            theme={identityMatrixTheme}
            language="html"
            showLineNumbers={false}
            wrapLongLines
            customStyle={{
              padding: "8px 10px",
              fontSize: "15px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              backgroundColor: "var(--color-gray-600)",
              borderRadius: "16px",
            }}
            text={PixelHelper.generateScript(companyPixel)}
            onCopy={() =>
              toast.success(
                "Your tracking pixel has been successfully copied to the clipboard"
              )
            }
          />
        </>
      ) : (
        <>
          <Empty
            type="no-code"
            title="No Pixel Code Found"
            message="You don't have a pixel generated yet, click bellow to create."
          />
          <div className="flex w-full justify-center items-center mt-4">
            <Button
              action="submit"
              onClick={handleCreatePixel}
              isProcessing={isAddLoading}
            >
              <Icon name="code" />
              Create Pixel
            </Button>
          </div>
        </>
      )}
      {addErrorMessage && <p>Error: {addErrorMessage}</p>}
    </div>
  );
};

export default CompanyPixel;
